<template>
  <div class="video-play-pagearea primary-page">
    <camp-player
      :play-pause-adv-data="advData"
      @handle-play="handlePlay"
      :key="$route.query.t"
      :show-watermark="true"
      :show-custom-control-bar="true"
      :detail-id="detailId"
      :duration="videoDuration"
    ></camp-player>

    <section class="details-wrapper">
      <div class="name">{{ contentDetails.name }}</div>
      <div class="flex-box">
        <template v-if="contentDetails.module_type !== 0">
          <div class="unlock-date" v-if="contentDetails.unlock_time">
            {{ contentDetails.unlock_time | dateStr }}
          </div>
          <div
            class="study-box"
            v-if="
              contentDetails.study_process_list &&
              contentDetails.study_process_list.length
            "
          >
            <span class="text">进度：</span>
            <div class="status-box">
              <div
                class="i-item"
                :class="{ finished: study.finished }"
                v-for="(study, sindex) in contentDetails.study_process_list"
                :key="sindex"
              >
                <i class="ic"></i>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="unlock-date">预习</div>
        </template>
      </div>
      <div
        class="comment-box"
        v-if="contentDetails.module_type === 1 && showComment"
        @click.stop="handleCommentEvent"
      >
        <div class="l-box">
          <span class="ready-box" v-if="contentDetails.comment_grade">
            本次课时体验
            <strong>{{
              contentDetails.comment_grade === 1 ? "“值得称赞”" : "“仍需改进”"
            }}</strong>
          </span>
          <span class="unready-box" v-else>觉得今天这节课怎么样？</span>
        </div>

        <div class="r-box" v-if="contentDetails.comment_grade">评价详情</div>
      </div>
      <div class="details-box">
        <div
          class="detail-item"
          :class="{
            'require-study': item.require_study,
            'finished-study': item.study_finished,
          }"
          v-for="(item, index) in contentDetails.details"
          :key="index"
        >
          <div
            class="in-box"
            :class="[
              item.class_name,
              { playing: lessonPlaying && lessonId === item.object_id },
            ]"
            @click.stop="handleDetailItemClick(item)"
          >
            <div class="title">
              <span class="text">{{ item.title }}</span>
              <span v-if="item.video_duration" class="m-nd-s">{{
                item.video_duration | durationStr
              }}</span>
            </div>
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-footer" v-if="detailId">
      <div class="btn-box">
        <div class="show-plan-btn" @click.stop="showSeriesPlanDialog = true">
          查看学习计划
        </div>
      </div>
    </section>

    <!-- 弹窗： 学习计划 -->
    <van-action-sheet
      class="play-series-dialog"
      v-model="showSeriesPlanDialog"
      title="学习计划"
      safe-area-inset-bottom
      :close-on-click-overlay="false"
    >
      <div class="dialog-main">
        <div
          class="type-wrap"
          v-for="(item, index) in seriesPlayList"
          :key="index"
        >
          <div
            class="content-item"
            :class="{
              'wait-unlock': !content.is_unlock,
              current: content.id === +contentId,
            }"
            v-for="(content, cindex) in item.contents"
            :key="cindex"
            @click.stop="handleContentClick(content)"
          >
            <div class="name" style="-webkit-box-orient: vertical;">{{ content.name }}</div>
            <div class="msg-box" v-if="item.type === 1">
              <div class="unlock-time" v-if="content.unlock_time">
                {{ content.unlock_time | dateStr }}
              </div>
              <div class="study-box" v-if="content.study_process_list.length">
                <span class="text">进度：</span>
                <div class="status-box">
                  <div
                    class="i-item"
                    :class="{ finished: study.finished }"
                    v-for="(study, sindex) in content.study_process_list"
                    :key="sindex"
                  >
                    <i class="ic"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <!-- 弹窗：课程评价 觉得今天这节课怎么样？ -->
    <van-action-sheet
      class="lesson-comment-dialog"
      v-model="showLessonCommentDialog"
      :title="contentDetails.comment_grade ? '  ' : '觉得今天这节课怎么样？'"
      safe-area-inset-bottom
      closeable
      :close-on-click-overlay="false"
    >
      <div class="dialog-main">
        <div v-if="!contentDetails.comment_grade" class="new-comment-dia">
          <div class="grade-choice-box">
            <div
              class="grade bad"
              :class="{ selected: grade === 2 }"
              @click.stop="handleGradeData(2)"
            >
              <i class="icon"></i>
              <div class="text">仍需改进</div>
              <i class="arrow-ic"></i>
            </div>
            <div
              class="grade good"
              :class="{ selected: grade === 1 }"
              @click.stop="handleGradeData(1)"
            >
              <i class="icon"></i>
              <div class="text">值得称赞</div>
              <i class="arrow-ic"></i>
            </div>
          </div>
          <div class="labels-box" v-if="currentLabels.length">
            <div
              class="i-box label"
              v-for="(item, index) in currentLabels"
              :key="index"
              :class="{ on: labels.includes(item) }"
              @click.stop="handleClickLabel(item)"
            >
              {{ item }}
            </div>
            <div
              class="i-box"
              :class="{ on: showAdviseTextarea }"
              @click.stop="showAdviseTextarea = !showAdviseTextarea"
            >
              <span>写评价</span>
            </div>
          </div>
          <div class="textarea-box" v-show="showAdviseTextarea" v-cloak>
            <van-field
              class="comment-input"
              v-model="advise"
              rows="4"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="说说你的感受吧~"
              show-word-limit
            />
          </div>
          <div class="bottom-btns">
            <div
              class="btn cancel"
              @click.stop="showLessonCommentDialog = false"
            >
              暂不评价
            </div>
            <div
              class="btn submit"
              :class="{ abled: grade }"
              @click.stop="submitComment"
            >
              提交
            </div>
          </div>
        </div>
        <div class="grade-res-box" v-else>
          <div
            class="res-box"
            :class="{
              good: contentDetails.comment_grade === 1,
              bad: contentDetails.comment_grade === 2,
            }"
          >
            <i class="icon"></i>
            <div class="text">
              {{ contentDetails.comment_grade === 1 ? "值得称赞" : "仍需改进" }}
            </div>
          </div>
          <div class="thanks">感谢您的宝贵意见~</div>
        </div>
      </div>
    </van-action-sheet>
    <CoumunitiesDialog :show="isShowProtocol" :courseId="seriesId" v-if="seriesId" />
  </div>
</template>

<script>
import {
  ActionSheet, Field, Toast, Dialog
} from 'vant';
import Cookies from 'js-cookie';
import campPlayer from '@/components/campPlayer/campPlayer.vue';
import {
  MODULE_DETAILS_OBJ_TYPE,
  ADV_TYPE,
  LESSON_TYPE,
} from '@/common/js/config';
import {
  getCampPlayContentDetails,
  // eslint-disable-next-line camelcase
  getCampSeriesPlayDetail_v4_0,
  submitLessonComment,
  getLessonCommentLabels,
  getAdv,
  getStudyFinished,
  getUserViewData,
  getCampSeriesSummary
} from '@/api/api';
import { isIos } from '@/common/js/utils';
import WxShare from '@/common/js/wxShare';

import CoumunitiesDialog from '@/components/coumunitiesDialog/index.vue';
import { getProtocolInfo } from '@/api/protocol';

export default {
  components: {
    campPlayer,
    [ActionSheet.name]: ActionSheet,
    [Field.name]: Field,
    CoumunitiesDialog
  },
  data() {
    return {
      lessonId: 0,
      contentId: 180,
      contentDetails: {},
      showSeriesPlanDialog: false,
      seriesPlayList: [],
      showLessonCommentDialog: false,
      currentLabels: [],
      badLabels: [],
      goodLabels: [],
      grade: 0,
      advise: '',
      labels: [],
      showAdviseTextarea: false,
      commentSubmitting: false,
      advData: {},

      videoUrls: [],

      lessonType: 0,
      sourceList: [],
      coverImage: '',
      teacherImage: '',

      lessonPlaying: false,

      showComment: false,
      detailInfoReady: false,

      detailId: 0,
      videoDuration: 0,
      isPaid: false,
      isPhone: false,
      isShowProtocol: false,
      seriesId: this.$route.params.lesson_id || 0
    };
  },
  filters: {
    durationStr(duration) {
      const minute = Math.floor(duration / 60) < 10
        ? `0${Math.floor(duration / 60)}`
        : Math.floor(duration / 60);
      const seconds = duration % 60 < 10
        ? `0${Math.floor(duration % 60)}`
        : Math.floor(duration % 60);
      return `${minute}:${seconds}`;
    },
    dateStr(time) {
      let res = time.replace(/-/g, '.');
      res = res.substr(0, 10);
      return res;
    },
  },
  watch: {
    $route(to) {
      this.lessonId = +to.params.lesson_id;
      this.contentId = +to.query.cid;
      this.seriesId = +to.query.sid;
      this.lessonType = +to.query.lt;
      this.detailInfoReady = false;

      this.advData = {};

      this.queryContentDetails(this.contentId);
      this.querySeriesPlayDetail(this.seriesId);
      if (this.lessonType === LESSON_TYPE.video) {
        this.queryPageAdv();
      }
    },
  },
  async created() {
    const userId = Cookies.get('user_id');
    if (!userId) {
      this.$router.replace({
        path: '/login',
        query: {
          redirect: `/camp-play/${this.$route.params.lesson_id}?cid=${this.$route.query.cid}&sid=${this.$route.query.sid}&lt=${this.$route.query.lt}`,
        },
      });
      return;
    }

    this.isPhone = isIos();
    this.lessonId = +this.$route.params.lesson_id;
    this.contentId = +this.$route.query.cid;
    // eslint-disable-next-line no-bitwise
    this.seriesId = this.$route.query.sid | 0;

    getProtocolInfo(this.seriesId).then((res) => {
      if (res.data) {
        this.isShowProtocol = !res.data.agree;
      }
    });

    await this.queryUserView();
    if (!this.isPaid) {
      return;
    }

    this.queryContentDetails(this.contentId);
    this.querySeriesPlayDetail(this.seriesId);
    if (this.lessonType === LESSON_TYPE.video) {
      this.queryPageAdv();
    }
  },
  methods: {
    // 用户信息
    queryUserView() {
      return new Promise((resolve) => {
        getUserViewData(this.seriesId).then((res) => {
          this.isPaid = res.data.is_paid;
          if (!res.data.is_paid) {
            Dialog.confirm({
              title: '请先购买课程',
              showCancelButton: false,
              confirmButtonColor: '#ff9645',
            })
              .then(() => {
                window.location.href = `${window.location.origin}/classroom/camp/${this.seriesId}`;
              })
              .catch(() => {});
          }
          resolve();
        });
      });
    },
    // 学习内容、小节列表
    queryContentDetails(contentId) {
      getCampPlayContentDetails(contentId).then((res) => {
        res.details.forEach((item) => {
          if (item.object_type === MODULE_DETAILS_OBJ_TYPE.live) {
            item.title = '直播';
            item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.live}`;
          } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.clock) {
            item.title = '打卡';
            item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.clock}`;
          } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.exam) {
            item.title = '考试';
            item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.exam}`;
          } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.material) {
            item.title = '资料';
            item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.material}`;
          } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.lesson) {
            item.title = '课程';
            if (
              item.lesson_type === LESSON_TYPE.video
              && item.object_id === this.lessonId
            ) {
              item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.lesson} lesson video current`;
              this.detailId = item.id;
              this.videoDuration = item.video_duration || 0;
            } else if (item.lesson_type === LESSON_TYPE.video) {
              item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.lesson} lesson video`;
            } else if (
              item.lesson_type === LESSON_TYPE.voice
              && item.object_id === this.lessonId
            ) {
              item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.lesson} lesson audio current`;
              this.detailId = item.id;
              this.videoDuration = item.video_duration || 0;
            } else if (item.lesson_type === LESSON_TYPE.voice) {
              item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.lesson} lesson audio`;
            } else {
              item.class_name = `detail-${MODULE_DETAILS_OBJ_TYPE.lesson} lesson video`;
            }
          }
        });

        res.study_process_list = this.makeStudyStatusArr(
          res.total_study,
          res.completed_study
        );

        // 完成了必修课则显示评论入口
        if (res.completed_study) {
          this.showComment = true;
        } else {
          this.showComment = false;
        }

        this.contentDetails = res;
        this.detailInfoReady = true;

        // 设置微信分享内容
        this.setWxShare(res.name, this.seriesId);
      });
    },
    querySeriesPlayDetail(seriesId) {
      getCampSeriesPlayDetail_v4_0(seriesId).then((res) => {
        res.items.forEach((item) => {
          item.contents.forEach((content) => {
            content.study_process_list = this.makeStudyStatusArr(
              content.total_study,
              content.completed_study
            );
          });
        });
        this.seriesPlayList = res.items;
      });
    },
    /**
     * @description 根据总学习数量和已完成数量，返回一个进度数组
     * @param {number} totalStudy 总数
     * @param {number} completedStudy 已完成数量
     */
    makeStudyStatusArr(totalStudy, completedStudy) {
      const arr = [];
      if (!totalStudy) {
        return arr;
      }

      for (let i = 1; i <= totalStudy; i++) {
        if (completedStudy >= i) {
          arr.push({
            finished: true
          });
        } else {
          arr.push({
            finished: false
          });
        }
      }

      // for (let i = 1; i <= totalStudy; i++) {
      //   const item = {
      //     finished: false
      //   };

      //   for (let j = completedStudy; j >= 1; j--) {
      //     item.finished = true;
      //     // eslint-disable-next-line no-plusplus
      //     completedStudy--;
      //     break;
      //   }
      //   arr.push(item);
      // }

      return arr;
    },
    handleCommentEvent() {
      if (this.contentDetails.comment_grade) {
        // 课程已有评价
        this.showLessonCommentDialog = true;
      } else {
        getLessonCommentLabels().then((res) => {
          this.badLabels = res.bad_labels;
          this.goodLabels = res.good_labels;
          this.initializeGradeData();
          this.showLessonCommentDialog = true;
        });
      }
    },
    handleGradeData(currentGrade) {
      if (this.grade === currentGrade) {
        return;
      }
      this.grade = currentGrade;
      this.advise = '';
      this.labels = [];
      this.showAdviseTextarea = false;
      if (currentGrade === 1) {
        this.currentLabels = this.goodLabels;
      } else if (currentGrade === 2) {
        this.currentLabels = this.badLabels;
      }
    },
    initializeGradeData() {
      this.currentLabels = [];
      this.grade = 0;
      this.advise = '';
      this.labels = [];
      this.showAdviseTextarea = false;
    },
    handleClickLabel(item) {
      if (this.labels.includes(item)) {
        this.labels.forEach((element, i) => {
          if (element === item) {
            this.labels.splice(i, 1);
          }
        });
      } else {
        this.labels.push(item);
      }
    },
    submitComment() {
      if (this.commentSubmitting) {
        return;
      }
      submitLessonComment(
        this.labels,
        this.grade,
        +this.contentId,
        this.advise
      ).then((res) => {
        if (res.data) {
          Toast(res.data);
          this.commentSubmitting = false;
          return;
        }
        this.commentSubmitting = false;
        this.contentDetails.comment_grade = this.grade;
      });
    },
    // 播放暂停广告
    queryPageAdv() {
      getAdv(ADV_TYPE.lesson_play_pause).then((res) => {
        this.advData = res;
      });
    },
    handleDetailItemClick(item) {
      if (
        item.object_type === MODULE_DETAILS_OBJ_TYPE.lesson
        && item.object_id === this.lessonId
        && (item.lesson_type === LESSON_TYPE.video
          || item.lesson_type === LESSON_TYPE.voice)
      ) {
        return;
      }
      this.lessonPlaying = false;
      if (item.object_type === MODULE_DETAILS_OBJ_TYPE.live) {
        // 直播
        window.location.href = item.metas.yjlive_url;
      } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.clock) {
        // 打卡
        this.$router.push({
          path: '/clock-in-theme',
          query: {
            id: item.id, // detail_id
          },
        });
      } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.exam) {
        // 考试
        Toast('功能开发中~');
      } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.material) {
        // 资料
        Toast('功能开发中~');
      } else if (item.object_type === MODULE_DETAILS_OBJ_TYPE.lesson) {
        // 课程
        if (
          item.lesson_type === LESSON_TYPE.video
          || item.lesson_type === LESSON_TYPE.voice
        ) {
          // 视频 || 音频
          this.$router.push({
            name: 'camp-play',
            params: {
              lesson_id: item.object_id,
            },
            query: {
              cid: this.contentId,
              lt: item.lesson_type,
              sid: this.seriesId,
              t: +new Date(),
            },
          });
        } else if (item.lesson_type === LESSON_TYPE.extUrl) {
          // 外链
          if (item.require_study) {
            getStudyFinished(item.id).then(() => {
              window.location.href = item.metas.ext_url;
            });
          } else {
            window.location.href = item.metas.ext_url;
          }
        }
      }
    },
    handleContentClick(content) {
      if (content.id === this.contentId) {
        this.showSeriesPlanDialog = false;
        return;
      }
      if (!content.is_unlock) {
        Toast('未解锁哦~');
        return;
      }
      this.lessonPlaying = false;
      for (let i = 0; i < content.details.length; i++) {
        const detail = content.details[i];
        if (
          detail.object_type === MODULE_DETAILS_OBJ_TYPE.lesson
          && (detail.lesson_type === LESSON_TYPE.video
            || detail.lesson_type === LESSON_TYPE.voice)
        ) {
          this.showSeriesPlanDialog = false;
          this.$router.push({
            name: 'camp-play',
            params: {
              lesson_id: detail.object_id,
            },
            query: {
              cid: content.id,
              lt: detail.lesson_type,
              sid: this.seriesId,
              t: +new Date(),
            },
          });
          break;
        } else if (i === content.details.length - 1) {
          this.showSeriesPlanDialog = false;
          this.$router.push({
            name: 'camp-play',
            params: {
              lesson_id: detail.object_id,
            },
            query: {
              cid: content.id,
              lt: detail.lesson_type,
              sid: this.seriesId,
              t: +new Date(),
            },
          });
        }
      }
    },
    handlePlay(isPlaying) {
      this.lessonPlaying = isPlaying;
    },
    /**
     * @description 设置微信分享内容
     * @param {string} title 主标题
     * @param {number} courseId 课程ID，不传则使用默认分享内容
     */
    setWxShare(title, courseId) {
      if (!courseId) {
        WxShare();
        return;
      }

      const shareData = {
        title
      };

      getCampSeriesSummary(courseId).then((share) => {
        document.title = share.name;

        shareData.desc = share.name;
        shareData.imgUrl = share.teacher_image;
        shareData.link = window.location.href;

        WxShare(shareData);
      });
    }
  },
  beforeDestroy() {
    // 页面销毁的时候重置分享内容
    WxShare();
  }
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';

.video-play-pagearea {
  min-height: 100vh;
  background: #fff;
}

.details-wrapper {
  width: 100%;
  padding: 16px 0 90px;

  .name {
    margin: 0 auto 12px;
    padding: 0 15px 0;
    font-size: 18px;
    font-weight: 600;
    color: #191919;
    line-height: 24px;
    multi-line(2);
  }

  .flex-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;

    .unlock-date {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 12px;
    }

    .study-box {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 12px;

      .status-box {
        display: flex;
        align-items: center;

        .i-item {
          display: flex;
          align-items: center;

          .ic {
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUxpcdvb29zc3N7e3tra2tzc3P///9ra2unp6dra2tvb29ra2tra2jVN3D0AAAAMdFJOUwDbUzfzQgWaDIql5p76EP0AAAB9SURBVBjTY2DAB9i0RBwXJUA5imeAQAjC5jwDBhPAnDkQzkkQm+nMmeMWzTVnzigAOYlnTgcwMLDuOSMG5OicOQpSEHPmEJBcc6YAxGE/cwpIypwxAHGYzxwEkj5nGkAcjjNH0DkoylAMQDEaxVIU56A4FNULKJ5D9TZ2AAAlWk1vcCOxSAAAAABJRU5ErkJggg==') center no-repeat;
            background-size: 12px;
          }

          &:not(:last-child)::after {
            content: '';
            display: block;
            width: 9px;
            height: 2px;
            margin: auto 2px;
            background: #DADADA;
            border-radius: 1px;
          }

          &.finished {
            .ic {
              background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAYFBMVEUAAAD/k0X/kkD/lkX/lkX/mET/l0b/lkX/lkX/lkT/lkX/lkX/lkX/lkX/l0f/mEn/mk3/m07/nVH/o13/rGz/0rD/2b3/2r7/3cT/5ND/5tP/8uj/8un/9/H/+PT///8DPboDAAAADXRSTlMAGhxOa22atuTy+Pv9Q6NETwAAAKlJREFUKM910kkWgyAQBNASkdGKMWbSaLj/LbNQXwCllv+xaKobWCOkNs4ZLQXiVMpzi1fV32vLKLbevWmZpG2295mTbQ0AleUhtgKgMrw8nqQChM/8FZaOXkAe/HsnKaFPnRrm1GngSN6uudPBkd3yGTKngyE5hnlInQaaZD+FeUiceh23n8L8jp1y+2A/hcS92CvpxyVyqqjELi+xWHt5UeXVlo/h7Hx+j8IZb4aP4FgAAAAASUVORK5CYII=') center no-repeat;
              background-size: 12px;
            }

            &:not(:last-child)::after {
              background: $color-theme;
            }
          }
        }
      }
    }
  }

  .comment-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 32px);
    height: 44px;
    margin: 16px auto 0;
    padding: 0 24px 0 12px;
    background: #FFF6EF url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAAD/lUD/m0b/lkX/l0b/lkX/lkX/lkX/lUX/lkX/lkUI7JZqAAAACnRSTlMADCGqrK2xw9nhFCoieAAAAC5JREFUGNNjYMAAzIlIHI7lAggO06xCJClNGks5IHMCsCtDMYCKEijeRgkQKAAAqyATdyRf7PoAAAAASUVORK5CYII=') center right 12px no-repeat;
    background-size: 12px;
    border-radius: 4px;
    color: $color-theme;

    .l-box {
      .unready-box {
        display: inline-flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;

        &::before {
          content: '评价';
          display: inline-block;
          margin-right: 6px;
          padding: 4px;
          background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
          border-radius: 2px;
          font-size: 12px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 12px;
        }
      }

      .ready-box {
        font-size: 14px;
        font-weight: 400;
        color: #FF9645;

        &>strong {
          font-weight: 500;
        }
      }
    }

    .r-box {
      font-size: 12px;
      font-weight: 400;
    }
  }

  .details-box {
    margin-top: 16px;

    .detail-item {
      padding: 8px 0;

      .in-box {
        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 35px;
          right: 12px;
          width: 12px;
          height: 12px;
          background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAACVlZWbm5uZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZntH403AAAACnRSTlMADCGqrK2xw9nhFCoieAAAAC5JREFUGNNjYMAAzIlIHI7lAggO06xCJClNGks5IHMCsCtDMYCKEijeRgkQKAAAqyATdyRf7PoAAAAASUVORK5CYII=') center no-repeat;
          background-size: cover;
        }

        &.lesson {
          &::after {
            display: none;
          }
        }
      }

      &.require-study {
        .in-box {
          &::before {
            content: '必修';
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: 36px;
            height: 16px;
            background: linear-gradient(270deg, #999999 0%, #CECBCB 100%);
            border-radius: 8px 0px 8px 0px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 16px;
            text-align: center;
          }
        }
      }

      &.finished-study {
        .in-box {
          &::after {
            content: '';
            position: absolute;
            top: unset;
            bottom: 0;
            right: 0;
            display: block;
            width: 64px;
            height: 45px;
            background: url('./img_catalog_complete@2x.png') center no-repeat;
            background-size: cover;
          }
        }
      }

      .in-box {
        position: relative;
        width: calc(100% - 32px);
        // height: 82px;
        margin: auto;
        padding: 24px 24px 24px 48px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;

        .title {
          display: inline-flex;
          align-items: center;

          .text {
            font-size: 14px;
            font-weight: 500;
            color: $color-text;
          }

          .m-nd-s {
            display: inline-block;
            margin-left: 8px;
            padding: 2px 4px;
            background: #F6F7FA;
            border-radius: 2px;
            font-size: 10px;
            font-weight: 400;
            color: #999999;
            line-height: 10px;
          }
        }

        .name {
          display: block;
          width: 100%;
          margin-top: 8px;
          margin-bottom: 0;
          padding: 0;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 12px;
          no-wrap();
        }

        // 课程
        &.detail-135 {
          // &.audio {
          // background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAnFBMVEUAAACqqqp/f3+ZmZmLi4uVlZWdnZ2bm5uXl5eenp6Xl5ednZ2ZmZmYmJiZmZmbm5uYmJiampqZmZmYmJiYmJiZmZmYmJiZmZmZmZmZmZmZmZmampqZmZmampqampqZmZmampqampqZmZmZmZmZmZmZmZmYmJiZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZksG7mgAAAAM3RSTlMAAwYKCwwNFxsdICIoLzI4PklLVFxwcoKKkZacp6uwsbW2w8jNztjc4ufq7vL09vn7/P5w+64EAAAA6UlEQVRIx+2SyxqBUBSFU5RQQrl2UZRcilrv/24mfRR7lwEjrdn+z/rPYJ8jCG3+NtJsvTtdr6fdeiZ9UO+vLnjksuo39ecJ8v3CUERRMRb7HMm8tt5zgK3+nPUt4PT4vhziPK2i6RmhzPU7PqLhKxxG8DuMsMRx8E4HRyzpvnbLxhQfZzeNFFxs6Js2cCmsZqlCC0qaqQS2YHPbsGER1IPJCSY8gh4w4oQRDgRN0OWELhKC5uC/AHIK1gn4mjCJ40kZFjMvxEBchsXMC0D1rJi/IwQBLwQBvw5SqNvfrwVmrXyYh2vTpjl3s6YktWUP6XgAAAAASUVORK5CYII=') top 28px left 12px no-repeat
          // background-size 24px
          // }
          // &.video {
          // background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAilBMVEUAAAAAAAAAAAAgICAXFxcaGhoYGBgXFxcXFxcWFhYcHBwbGxsYGBgYGBgaGhoYGBgXFxcaGhoaGhoaGhoZGRkaGhoZGRkYGBgYGBgZGRkZGRkZGRkZGRkYGBgaGhoZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkYGBgZGRkZGRkZGRkZGRkZGRkZGRkihYc7AAAALXRSTlMAAwYICxQVFiEiJDk/QERKV1hiY2hten5/hZikqrKzxMrNztfa6+/x8/j5/f6OrXxbAAABNUlEQVRIx+2V21qDMBCEU5CmFa1FgSIHAREUyP/+r+eVLaGkNb3u3u2ww7eZ3UyEuMdNsQmzuu37ts7CzfXqVVAqjqHKYHW5ftcwi2Z3odxNFTAUkS8dR/pRMQAqdU316wroEu+EeEkHVGtDfQPkUgdlDjSLDLeCMT7H4xGqpa5SGPdLf9qPkC7ooyBe7jUGdabVqoHcpEYOzXweAXTSRJAdBDOshIN5QAmUOrJVDJ6Z4A0ofa9CKCbp06ujMwoINSCDaJL+8PWifY8g04Aa/EkK8PE4AXyoNUILckagf3846QStRujBmRPg8wg40P+DUJsJ1i1ZH3om6/dVWWeDe367Njjr1RAlJDbLZ7/e1hfI+oram4C9zVgb2Z9VHqZWebhklfZmbG/3NzwoQgixtXqy7rEUv1i5PlGq261dAAAAAElFTkSuQmCC') top 28px left 12px no-repeat
          // background-size 24px
          // }
          background: url('../../common/images/catalog_icon_lesson@2x.png') top 28px left 12px no-repeat;
          background-size: 24px;

          &.current {
            background: url('../../common/images/catalog_icon_loading@2x.png') top 28px left 12px no-repeat;
            background-size: 24px;
          }

          &.playing {
            background: url('../../common/images/catalog_icon_playing.gif') top 28px left 12px no-repeat;
            background-size: 24px;
          }
        }

        // 打卡
        &.detail-131 {
          background: url('../../common/images/catalog_icon_clockin@2x.png') top 28px left 12px no-repeat;
          background-size: 24px;
        }

        // 考试
        &.detail-132 {
          background: url('../../common/images/catalog_icon_test@2x.png') top 28px left 12px no-repeat;
          background-size: 24px;
        }

        // 资料
        &.detail-133 {
          background: url('../../common/images/catalog_icon_data@2x.png') top 28px left 12px no-repeat;
          background-size: 24px;
        }

        // 直播
        &.detail-93 {
          background: url('../../common/images/catalog_icon_live2@2x.png') top 28px left 12px no-repeat;
          background-size: 24px;
        }
      }
    }
  }
}

.page-footer {
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 640px;
  margin: auto;

  .btn-box {
    width: 100%;
    background: #fff;
    padding: 5px 15px 4px;

    .show-plan-btn {
      width: 100%;
      padding: 12px 0;
      background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
      border-radius: 20px;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 16px;
      text-align: center;
    }
  }
}

.play-series-dialog {
  max-height: 73%;

  .dialog-main {
    width: 100%;
    padding: 12px 16px;

    .type-wrap {
      .content-item {
        width: 100%;
        margin-bottom: 16px;
        padding: 16px;
        background: #F6F7FA;
        border-radius: 4px;

        .name {
          font-size: 16px;
          font-weight: 500;
          color: $color-text;
          line-height: 24px;
          multi-line(2);
        }

        .msg-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 6px;

          .unlock-time {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 12px;
          }

          .study-box {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 12px;

            .status-box {
              display: flex;
              align-items: center;

              .i-item {
                display: flex;
                align-items: center;

                .ic {
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUxpcdvb29zc3N7e3tra2tzc3P///9ra2unp6dra2tvb29ra2tra2jVN3D0AAAAMdFJOUwDbUzfzQgWaDIql5p76EP0AAAB9SURBVBjTY2DAB9i0RBwXJUA5imeAQAjC5jwDBhPAnDkQzkkQm+nMmeMWzTVnzigAOYlnTgcwMLDuOSMG5OicOQpSEHPmEJBcc6YAxGE/cwpIypwxAHGYzxwEkj5nGkAcjjNH0DkoylAMQDEaxVIU56A4FNULKJ5D9TZ2AAAlWk1vcCOxSAAAAABJRU5ErkJggg==') center no-repeat;
                  background-size: 12px;
                }

                &:not(:last-child)::after {
                  content: '';
                  display: block;
                  width: 9px;
                  height: 2px;
                  margin: auto 2px;
                  background: #DADADA;
                  border-radius: 1px;
                }

                &.finished {
                  .ic {
                    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAYFBMVEUAAAD/k0X/kkD/lkX/lkX/mET/l0b/lkX/lkX/lkT/lkX/lkX/lkX/lkX/l0f/mEn/mk3/m07/nVH/o13/rGz/0rD/2b3/2r7/3cT/5ND/5tP/8uj/8un/9/H/+PT///8DPboDAAAADXRSTlMAGhxOa22atuTy+Pv9Q6NETwAAAKlJREFUKM910kkWgyAQBNASkdGKMWbSaLj/LbNQXwCllv+xaKobWCOkNs4ZLQXiVMpzi1fV32vLKLbevWmZpG2295mTbQ0AleUhtgKgMrw8nqQChM/8FZaOXkAe/HsnKaFPnRrm1GngSN6uudPBkd3yGTKngyE5hnlInQaaZD+FeUiceh23n8L8jp1y+2A/hcS92CvpxyVyqqjELi+xWHt5UeXVlo/h7Hx+j8IZb4aP4FgAAAAASUVORK5CYII=') center no-repeat;
                    background-size: 12px;
                  }

                  &:not(:last-child)::after {
                    background: $color-theme;
                  }
                }
              }
            }
          }
        }

        &.wait-unlock {
          .name {
            color: #999999;
          }

          .msg-box {
            .unlock-time {
              color: #999999;
            }
          }
        }

        &.current {
          .name {
            color: $color-theme;
          }

          .msg-box {
            .unlock-time {
              color: $color-theme;
            }

            .study-box {
              color: $color-theme;
            }
          }
        }
      }
    }
  }

  /deep/ .van-action-sheet__header {
    height: 44px;
    font-size: 18px;
    font-weight: 500;
    color: #191919;
  }
}

/deep/.van-popup--bottom.van-popup--round {
  border-radius: 12px 12px 0 0;
}

.lesson-comment-dialog {
  max-height 100%

  .dialog-main {
    position: relative;
    padding: 0 16px;

    .grade-choice-box {
      display: flex;
      align-items: center;
      justify-content: center;

      .grade {
        position: relative;
        padding-bottom: 18px;

        .icon {
          display: block;
          width: 60px;
          height: 60px;
        }

        .text {
          margin-top: 8px;
          font-size: 14px;
          font-weight: 400;
          color: #999;
          line-height: 14px;
          text-align: center;
        }

        .arrow-ic {
          display: none;
        }

        &.bad {
          margin-right: 84px;

          .icon {
            background: url('../../common/images/learn_icon_bad_de@2x.png') center no-repeat;
            background-size: cover;
          }
        }

        &.good {
          .icon {
            background: url('../../common/images/learn_icon_good_de@2x.png') center no-repeat;
            background-size: cover;
          }
        }

        &.selected {
          .text {
            font-weight: 500;
            color: $color-text;
          }

          .arrow-ic {
            position: absolute;
            display: block;
            left: 0;
            right: 0;
            bottom: -1px;
            margin: auto;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 8px 8px;
            border-color: transparent transparent #E7E7E7;

            &::after {
              content: '';
              border-style: solid;
              border-width: 0 6px 6px;
              border-color: transparent transparent #fff;
              position: absolute;
              top: 2px;
              left: -6px;
            }
          }

          &.bad {
            .icon {
              background: url('../../common/images/learn_icon_bad_se@2x.png') center no-repeat;
              background-size: cover;
            }
          }

          &.good {
            .icon {
              background: url('../../common/images/learn_icon_good_se@2x.png') center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }

    .labels-box {
      display: flex;
      flex-wrap: wrap;
      padding: 12px 0;
      border-top: 1px solid #e7e7e7;

      .i-box {
        width: 30.904%;
        height: 30px;
        margin-bottom: 12px;
        background: #F6F7FA;
        border-radius: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        text-align: center;

        &:not(:nth-child(3n)) {
          margin-right: 2.041%;
        }

        &>span {
          display: inline-flex;
          align-items: center;

          &::before {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-right: 2px;
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAS1BMVEUAAACqqqqenp6ZmZmYmJiZmZmYmJiYmJiampqampqYmJiampqZmZmZmZmampqZmZmYmJiZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmSt7TmAAAAGHRSTlMADBUjKjI5Q11iZm14hYaHlaqxu8Pt8vihQdJoAAAAV0lEQVQoz8XLWw5AMBRF0aMURSl9nfmP1ADurcSH2J8r2YBomaG2k5vmXSQ5ST+Sicy9dDKZ02pOXtA92898/8nXhiM0HKHhGJ0b8CJfKaoeQKFSeToa3fhYDkmnhJiiAAAAAElFTkSuQmCC') center no-repeat;
            background-size: cover;
          }
        }

        &.on {
          background: #FFF6EF;
          font-size: 14px;
          font-weight: 400;
          color: #FF9645;

          &>span {
            &::before {
              background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAA4VBMVEUAAAD/v0D/niT/qjH/kh3/kh76jxn6jx/7nS3/lCL8qjf8kiL8mir8rzz9rz37nS37jh/7sD39sD/9rz39rz/9sT/7sDz9sD78ozL8qTj6kCH8kiH8ni38qjn7nSz8qjr6kCD7kCD7kCH7jR79sD77jx/8rz39rz36jh/6kCH6kSL6kiL6kyT6lSX6lib6lif6lyf6mCj6mir6myv6nSz6nS37nCv7nSz7nS37ny77ny/7oTD7ojH7ojL7ozL7pDL7pDP7pjT7pjX7pzb7qTj7qjj7qjn7qzn7rDv8rTv8rjwKctRAAAAAKHRSTlMADBUVIyoyMjlDXWJiZm14hYWFhoaGh4eVlaqxu7vDw+3t7fLy+Pj4VOSewQAAALhJREFUKM+VjscCgjAQRGPvvWAX7AUiIEoQJVhA9P8/yFhuWQ7OcWZ29iHEqZBFoOoeLUF+pE8NnOF9YRjrYSnO+54ziHZSnN/0HYK7COqbWExCvrGR+B3BpwTuUxOP+H7NY/zATsNnfyGf/VVFYOfND/dB/mIIP2rD/Ai1QH6mdD6XQH+oOnvcb9eL69gHstU1rMjr5bTMgskzYMHZPdkW2euaqsir5WLMgso8+FwcbWv3DX4XIXoBOuAerNaubxYAAAAASUVORK5CYII=') center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }

    .textarea-box {
      padding: 11px 0 16px;

      .comment-input {
        width: 100%;
        // height: 120px;
        padding: 8px 12px;
        background: #F6F7FA;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: $color-text;

        // line-height: 12px;
        /deep/ .van-field__word-limit {
          font-weight: 400;
          color: #DADADA;
          line-height: 12px;
        }
      }
    }

    .bottom-btns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 5px 16px 4px;
      background: #FFFFFF;

      .btn {
        width: 48.689%;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #DADADA;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 40px;
        text-align: center;

        &.submit {
          background: #E7E7E7;
          font-weight: 500;
          color: #FFFFFF;
          border: none;

          &.abled {
            background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
          }
        }
      }
    }

    .grade-res-box {
      height: 170px;

      .res-box {
        .icon {
          display: block;
          margin: auto;
          width: 60px;
          height: 60px;
        }

        .text {
          margin-top: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #191919;
          line-height: 14px;
          text-align: center;
        }

        &.good {
          .icon {
            background: url('../../common/images/learn_icon_good_se@2x.png') center no-repeat;
            background-size: cover;
          }
        }

        &.bad {
          .icon {
            background: url('../../common/images/learn_icon_bad_se@2x.png') center no-repeat;
            background-size: cover;
          }
        }
      }

      .thanks {
        margin-top: 24px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        text-align: center;
      }
    }
  }

  /deep/ .van-action-sheet__header {
    font-size: 20px;
    font-weight: 500;
    color: #191919;
    margin: 0 auto 12px;
    padding-top: 20px;
  }
}

.new-comment-dia {
  min-height 187px
}
</style>
